export default __webpack_public_path__ + "static/media/KZ.Т.12.2528 Kazaly.1e8dfaa1.svg";